module.exports = __webpack_public_path__ + "static/media/How-to-Get-the-Best-Cash-Offer-for-Your-Car-in-Acacia-Ridge.1a7d6eed.jpg";